var React = require('react');

function FacebookShare (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#clip0_1354_40)","key":0},React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M15 0.761475C6.71573 0.761475 0 7.26945 0 15.2975C0 23.3255 6.71573 29.8334 15 29.8334C23.2843 29.8334 30 23.3255 30 15.2975C30 7.26945 23.2843 0.761475 15 0.761475ZM16.0635 15.4514V23.3598H12.6869V15.4517H11V12.7265H12.6869V11.0902C12.6869 8.86698 13.6395 7.54493 16.3457 7.54493H18.5988V10.2705H17.1905C16.137 10.2705 16.0673 10.6514 16.0673 11.3621L16.0635 12.7262H18.6147L18.3162 15.4514H16.0635Z","fill":"#00443B"})),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0_1354_40"},React.createElement("rect",{"width":"30","height":"30","fill":"white"})))]);
}

FacebookShare.defaultProps = {"width":"30","height":"30","viewBox":"0 0 30 30","fill":"none"};

module.exports = FacebookShare;

FacebookShare.default = FacebookShare;
